import { useEffect, useRef } from "react";

export function ReclameAquiSeal() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.id = "ra-embed-verified-seal";
    script.src = "https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js";
    script.setAttribute("data-id", "YlpxN3pXaTRjd0ZSRmZ4MTp2b29wdGVy");
    script.setAttribute("data-target", "ra-verified-seal");
    script.setAttribute("data-model", "2");

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      id="ra-verified-seal"
      style={{ margin: "0 auto" }}
      ref={containerRef}
    />
  );
}
